import React, { useState } from 'react';
import './SolicitudIMSS.css';
import { getCurrentUser } from '../services/authService';

const SolicitudIMSS = ({ user, onClose, onSubmit }) => {
  const [tipoSolicitud, setTipoSolicitud] = useState('alta');
  const [formData, setFormData] = useState({
    // Campos comunes
    nombreEmpresa: '',
    emailContacto: '',
    nombreCompleto: '',
    nss: '',
    
    // Campos para Alta
    rfc: '',
    fechaAlta: '',
    salarioDiario: '',
    salarioDiarioIntegrado: '',
    
    // Campos para Baja
    fechaBaja: '',
    motivoBaja: '',
    tipoBaja: '',
    
    // Otros
    comentarios: ''
  });

  const [archivos, setArchivos] = useState([]);
  const [errores, setErrores] = useState({});
  const [enviando, setEnviando] = useState(false);

  const tiposBaja = [
    'Renuncia voluntaria',
    'Término de contrato',
    'Despido justificado',
    'Despido injustificado',
    'Mutuo consentimiento',
    'Jubilación',
    'Defunción',
    'Otro'
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    // Limpiar error al escribir
    if (errores[name]) {
      setErrores({
        ...errores,
        [name]: ''
      });
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setArchivos([...archivos, ...files]);
  };

  const removeFile = (index) => {
    setArchivos(archivos.filter((_, i) => i !== index));
  };

  const validarFormulario = () => {
    const nuevosErrores = {};

    // Validaciones comunes

    if (!formData.nombreEmpresa.trim()) {           // ← AGREGAR
      nuevosErrores.nombreEmpresa = 'El nombre de la empresa es obligatorio';
    }

    if (!formData.nombreCompleto.trim()) {
      nuevosErrores.nombreCompleto = 'El nombre completo es obligatorio';
    }

    if (!formData.emailContacto.trim()) {
        nuevosErrores.emailContacto = 'El email de contacto es obligatorio';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailContacto)) {
        nuevosErrores.emailContacto = 'Email inválido';
    }

    if (!formData.nss.trim()) {
      nuevosErrores.nss = 'El NSS es obligatorio';
    } else if (!/^\d{11}$/.test(formData.nss.replace(/\s/g, ''))) {
      nuevosErrores.nss = 'El NSS debe tener 11 dígitos';
    }

    if (tipoSolicitud === 'alta') {
      // Validaciones para Alta
      if (!formData.rfc.trim()) {
        nuevosErrores.rfc = 'El RFC es obligatorio';
      } else if (!/^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/i.test(formData.rfc)) {
        nuevosErrores.rfc = 'RFC inválido';
      }

      if (!formData.fechaAlta) {
        nuevosErrores.fechaAlta = 'La fecha de alta es obligatoria';
      }

      if (!formData.salarioDiario || parseFloat(formData.salarioDiario) <= 0) {
        nuevosErrores.salarioDiario = 'El salario diario es obligatorio';
      }

      if (!formData.salarioDiarioIntegrado || parseFloat(formData.salarioDiarioIntegrado) <= 0) {
        nuevosErrores.salarioDiarioIntegrado = 'El salario diario integrado es obligatorio';
      }

      // Validar que SDI >= SD
      if (parseFloat(formData.salarioDiarioIntegrado) < parseFloat(formData.salarioDiario)) {
        nuevosErrores.salarioDiarioIntegrado = 'El SDI debe ser mayor o igual al salario diario';
      }
    } else {
      // Validaciones para Baja
      if (!formData.fechaBaja) {
        nuevosErrores.fechaBaja = 'La fecha de baja es obligatoria';
      }

      if (!formData.motivoBaja.trim()) {
        nuevosErrores.motivoBaja = 'El motivo de baja es obligatorio';
      }

      if (!formData.tipoBaja) {
        nuevosErrores.tipoBaja = 'El tipo de baja es obligatorio';
      }
    }

    setErrores(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validarFormulario()) {
      return;
    }

    setEnviando(true);

    try {
    const solicitud = {
        tipo: tipoSolicitud,
        fecha_solicitud: new Date().toISOString(),
        cliente: formData.nombreEmpresa || user?.email || 'Cliente',
        emailCliente: formData.emailContacto || 'sin-email@ejemplo.com',
        estado: 'pendiente',
        datos: formData,
        archivos: archivos.map(f => f.name)
    };
    
    // Aquí debe continuar el código del try
    // Probablemente hay una llamada a onSubmit(solicitud, archivos);

      await onSubmit(solicitud, archivos);
      
      // Limpiar formulario
      setFormData({
        nombreEmpresa: '',
        emailContacto: '',
        nombreCompleto: '',
        nss: '',
        rfc: '',
        fechaAlta: '',
        salarioDiario: '',
        salarioDiarioIntegrado: '',
        fechaBaja: '',
        motivoBaja: '',
        tipoBaja: '',
        comentarios: ''
      });
      setArchivos([]);
      
    } catch (error) {
      console.error('Error al enviar solicitud:', error);
      alert('Error al enviar la solicitud. Por favor intente de nuevo.');
    } finally {
      setEnviando(false);
    }
  };

  const formatCurrency = (value) => {
    if (!value) return '';
    const num = parseFloat(value);
    return isNaN(num) ? '' : `$${num.toFixed(2)}`;
  };

  return (
    <div className="solicitud-imss-container">
      <div className="solicitud-header">
        <h2>📝 Solicitud de {tipoSolicitud === 'alta' ? 'Alta' : 'Baja'} IMSS</h2>
        <button onClick={onClose} className="close-btn">
          <i className="fas fa-times"></i>
        </button>
      </div>

      <form onSubmit={handleSubmit} className="solicitud-form">
        {/* Tipo de Solicitud */}
        <div className="tipo-solicitud">
          <label className="radio-option">
            <input
              type="radio"
              name="tipo"
              value="alta"
              checked={tipoSolicitud === 'alta'}
              onChange={(e) => setTipoSolicitud(e.target.value)}
            />
            <span className="radio-label">
              <i className="fas fa-user-plus"></i> Alta
            </span>
          </label>
          <label className="radio-option">
            <input
              type="radio"
              name="tipo"
              value="baja"
              checked={tipoSolicitud === 'baja'}
              onChange={(e) => setTipoSolicitud(e.target.value)}
            />
            <span className="radio-label">
              <i className="fas fa-user-minus"></i> Baja
            </span>
          </label>
        </div>

        <div className="form-section">
          <h3>Datos del Trabajador</h3>

<div className="form-section">
  <h3>Información de Contacto</h3>
  
  <div className="form-row">
    <div className="form-group">
      <label>
        Nombre de la Empresa <span className="required">*</span>
      </label>
      <input
        type="text"
        name="nombreEmpresa"
        value={formData.nombreEmpresa}
        onChange={handleInputChange}
        placeholder="Ej: Empresa Demo SA de CV"
        className={errores.nombreEmpresa ? 'error' : ''}
      />
      {errores.nombreEmpresa && (
        <span className="error-message">{errores.nombreEmpresa}</span>
      )}
    </div>
  </div>

  <div className="form-row">
    <div className="form-group">
      <label>
        Email de Contacto <span className="required">*</span>
      </label>
      <input
        type="email"
        name="emailContacto"
        value={formData.emailContacto}
        onChange={handleInputChange}
        placeholder="correo@empresa.com"
        className={errores.emailContacto ? 'error' : ''}
      />
      {errores.emailContacto && (
        <span className="error-message">{errores.emailContacto}</span>
      )}
    </div>
  </div>
</div>

<div className="form-section">
  <h3>Datos del Trabajador</h3>
  {/* ... resto del código ... */}
          
          <div className="form-row">
            <div className="form-group">
              <label>
                Nombre Completo <span className="required">*</span>
              </label>
              <input
                type="text"
                name="nombreCompleto"
                value={formData.nombreCompleto}
                onChange={handleInputChange}
                placeholder="Nombre(s) Apellido Paterno Apellido Materno"
                className={errores.nombreCompleto ? 'error' : ''}
              />
              {errores.nombreCompleto && (
                <span className="error-message">{errores.nombreCompleto}</span>
              )}
            </div>
          </div>
         </div>

          <div className="form-row">
            <div className="form-group">
              <label>
                NSS (Número de Seguridad Social) <span className="required">*</span>
              </label>
              <input
                type="text"
                name="nss"
                value={formData.nss}
                onChange={handleInputChange}
                placeholder="12345678901"
                maxLength="11"
                className={errores.nss ? 'error' : ''}
              />
              {errores.nss && (
                <span className="error-message">{errores.nss}</span>
              )}
            </div>
          </div>
        </div>

        {tipoSolicitud === 'alta' && (
          <div className="form-section">
            <h3>Datos del Alta</h3>
            
            <div className="form-row">
              <div className="form-group">
                <label>
                  RFC <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="rfc"
                  value={formData.rfc}
                  onChange={handleInputChange}
                  placeholder="AAAA000000XXX"
                  maxLength="13"
                  style={{ textTransform: 'uppercase' }}
                  className={errores.rfc ? 'error' : ''}
                />
                {errores.rfc && (
                  <span className="error-message">{errores.rfc}</span>
                )}
              </div>

              <div className="form-group">
                <label>
                  Fecha de Alta <span className="required">*</span>
                </label>
                <input
                  type="date"
                  name="fechaAlta"
                  value={formData.fechaAlta}
                  onChange={handleInputChange}
                  className={errores.fechaAlta ? 'error' : ''}
                />
                {errores.fechaAlta && (
                  <span className="error-message">{errores.fechaAlta}</span>
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>
                  Salario Diario <span className="required">*</span>
                </label>
                <input
                  type="number"
                  name="salarioDiario"
                  value={formData.salarioDiario}
                  onChange={handleInputChange}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                  className={errores.salarioDiario ? 'error' : ''}
                />
                {formData.salarioDiario && (
                  <span className="input-hint">
                    {formatCurrency(formData.salarioDiario)}
                  </span>
                )}
                {errores.salarioDiario && (
                  <span className="error-message">{errores.salarioDiario}</span>
                )}
              </div>

              <div className="form-group">
                <label>
                  Salario Diario Integrado <span className="required">*</span>
                </label>
                <input
                  type="number"
                  name="salarioDiarioIntegrado"
                  value={formData.salarioDiarioIntegrado}
                  onChange={handleInputChange}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                  className={errores.salarioDiarioIntegrado ? 'error' : ''}
                />
                {formData.salarioDiarioIntegrado && (
                  <span className="input-hint">
                    {formatCurrency(formData.salarioDiarioIntegrado)}
                  </span>
                )}
                {errores.salarioDiarioIntegrado && (
                  <span className="error-message">{errores.salarioDiarioIntegrado}</span>
                )}
              </div>
            </div>
          </div>
        )}

        {tipoSolicitud === 'baja' && (
          <div className="form-section">
            <h3>Datos de la Baja</h3>
            
            <div className="form-row">
              <div className="form-group">
                <label>
                  Fecha de Baja <span className="required">*</span>
                </label>
                <input
                  type="date"
                  name="fechaBaja"
                  value={formData.fechaBaja}
                  onChange={handleInputChange}
                  className={errores.fechaBaja ? 'error' : ''}
                />
                {errores.fechaBaja && (
                  <span className="error-message">{errores.fechaBaja}</span>
                )}
              </div>

              <div className="form-group">
                <label>
                  Tipo de Baja <span className="required">*</span>
                </label>
                <select
                  name="tipoBaja"
                  value={formData.tipoBaja}
                  onChange={handleInputChange}
                  className={errores.tipoBaja ? 'error' : ''}
                >
                  <option value="">Seleccione un tipo...</option>
                  {tiposBaja.map(tipo => (
                    <option key={tipo} value={tipo}>{tipo}</option>
                  ))}
                </select>
                {errores.tipoBaja && (
                  <span className="error-message">{errores.tipoBaja}</span>
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>
                  Motivo de Baja <span className="required">*</span>
                </label>
                <textarea
                  name="motivoBaja"
                  value={formData.motivoBaja}
                  onChange={handleInputChange}
                  placeholder="Describa el motivo de la baja..."
                  rows="3"
                  className={errores.motivoBaja ? 'error' : ''}
                ></textarea>
                {errores.motivoBaja && (
                  <span className="error-message">{errores.motivoBaja}</span>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Documentos */}
        {tipoSolicitud === 'alta' && (
          <div className="form-section">
            <h3>Documentos (Opcionales)</h3>
            <p className="section-note">
              Puede adjuntar: Constancia de Situación Fiscal, Comprobante de número de IMSS
            </p>
            
            <div className="file-upload-area">
              <label className="file-upload-label">
                <i className="fas fa-cloud-upload-alt"></i>
                <span>Seleccionar archivos</span>
                <input
                  type="file"
                  multiple
                  onChange={handleFileChange}
                  accept=".pdf,.jpg,.jpeg,.png"
                  style={{ display: 'none' }}
                />
              </label>
              
              {archivos.length > 0 && (
                <div className="files-list">
                  {archivos.map((file, index) => (
                    <div key={index} className="file-item">
                      <i className="fas fa-file"></i>
                      <span>{file.name}</span>
                      <button
                        type="button"
                        onClick={() => removeFile(index)}
                        className="remove-file"
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Comentarios */}
        <div className="form-section">
          <h3>Comentarios Adicionales</h3>
          <textarea
            name="comentarios"
            value={formData.comentarios}
            onChange={handleInputChange}
            placeholder="Información adicional que desee agregar..."
            rows="4"
          ></textarea>
        </div>

        {/* Botones */}
        <div className="form-actions">
          <button type="button" onClick={onClose} className="btn-cancel">
            Cancelar
          </button>
          <button type="submit" className="btn-submit" disabled={enviando}>
            {enviando ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                Enviando...
              </>
            ) : (
              <>
                <i className="fas fa-paper-plane"></i>
                Enviar Solicitud
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SolicitudIMSS;
